import { Icon, Stack } from '@ui-components/neo.tax';
import { ReactComponent as ChevronDownIcon } from '@ui-components/neo.tax/dist/icons/chevron-down.svg';
import { ReactComponent as MergeIcon } from '@ui-components/neo.tax/dist/icons/merge.svg';
import { ReactComponent as TagIcon } from '@ui-components/neo.tax/dist/icons/tag.svg';
import { MenuButton, useMenuState } from 'ariakit';
import { ReactElement } from 'react';

import {
  StyledMenuButton,
  ActionsMenu,
  ActionsMenuItem,
  ActionsMenuItemHint,
  ActionsMenuItemIcon,
  ActionsMenuItemLabel,
  ActionsMenuItemText,
} from './asc-projects-actions-dropdown.styled';

type AscProjectsActionsDropdownProps = {
  canMerge: boolean;
  mergeAnalyticId?: string;
  mergeDisabledReason?: string;
  onMerge: () => void;
  onUpdateMatchingTarget?: () => void;
  showMatchingTargetAction: boolean;
};

export const AscProjectsActionsDropdown = ({
  canMerge,
  mergeAnalyticId,
  mergeDisabledReason,
  onMerge,
  onUpdateMatchingTarget,
  showMatchingTargetAction,
}: AscProjectsActionsDropdownProps): ReactElement => {
  const menuState = useMenuState({ gutter: 6, placement: 'bottom-end' });
  const canUpdateMatchingTarget = Boolean(onUpdateMatchingTarget);
  const matchingTargetHint = canUpdateMatchingTarget ? undefined : 'Select at least one project';

  return (
    <>
      <StyledMenuButton as={MenuButton} state={menuState} size="sm" variant="primary" rounded="regular">
        <Stack direction="row" alignItems="center" gap={2}>
          <span>Actions</span>
          <Icon size={2} node={<ChevronDownIcon />} />
        </Stack>
      </StyledMenuButton>
      <ActionsMenu state={menuState} portal aria-label="ASC projects actions">
        <ActionsMenuItem
          id={mergeAnalyticId}
          disabled={!canMerge}
          onClick={(): void => {
            menuState.hide();
            onMerge();
          }}
        >
          <ActionsMenuItemIcon size={4} node={<MergeIcon />} />
          <ActionsMenuItemText>
            <ActionsMenuItemLabel>Merge</ActionsMenuItemLabel>
            {!canMerge && mergeDisabledReason && <ActionsMenuItemHint>{mergeDisabledReason}</ActionsMenuItemHint>}
          </ActionsMenuItemText>
        </ActionsMenuItem>
        {showMatchingTargetAction && (
          <ActionsMenuItem
            disabled={!canUpdateMatchingTarget}
            onClick={(): void => {
              menuState.hide();
              onUpdateMatchingTarget?.();
            }}
          >
            <ActionsMenuItemIcon size={4} node={<TagIcon />} />
            <ActionsMenuItemText>
              <ActionsMenuItemLabel>Update Next Sync Matching</ActionsMenuItemLabel>
              {matchingTargetHint && <ActionsMenuItemHint>{matchingTargetHint}</ActionsMenuItemHint>}
            </ActionsMenuItemText>
          </ActionsMenuItem>
        )}
      </ActionsMenu>
    </>
  );
};
